export enum TestIds {
  paymentDetailsForm = `payment-details-form`,
  openTaxesModalLink = 'open-taxes-modal-link',
  taxesModal = 'taxes-modal',
  inputErrorMessage = 'input-error-message',
  cardNumberInput = 'card-number-input',
  cardExpirationDateInput = 'card-expiration-date-input',
  summaryPaymentItem = 'summary-payment-item',
  summaryPaymentItemPrice = 'summary-payment-item-price',
  summaryTotalPrice = 'summary-total-price',
}
